export const blockIconsDeviceMedication = (
	<span className='material-symbols-outlined'>medication</span>
);
